import React from 'react'

interface NoCenterProps {
  removeFilters: () => void
  isBe: boolean
  hostname: string
}
const NoCenter: React.FC<NoCenterProps> = ({
  removeFilters,
  isBe,
  hostname,
}: NoCenterProps) => {
  return (
    <div>
      <a
        className="is-size-10 has-text-primary is-block has-text-right mb-0 mt-3"
        onClick={removeFilters}
        href="#"
      >
        Voir tous les centres en {isBe ? 'Belgique' : 'France'}
      </a>
      <div className="content box is-3 is-shadowless b-1 mt-7">
        <div className="is-size-9 has-text-weight-bold has-text-heading">
          Aucune adresse ne correspond à votre recherche.
        </div>
        <ul>
          <li>
            Contactez notre équipe gratuitement pour obtenir échanger sur votre
            besoin.
          </li>
          <li>
            Essayez de trouver une nouvelle adresse en sélectionnant une autre
            ville dans les filtres.
          </li>
        </ul>
        {isBe ? (
          <a
            href={`${window.location.protocol}//${hostname}/adresses`}
            className="button is-blue is-outlined"
          >
            Visiter le site FR
          </a>
        ) : (
          <a href="/etre-contacte" className="button is-blue is-outlined">
            Nous Contacter
          </a>
        )}
      </div>
    </div>
  )
}

export default NoCenter
